import React, { useState } from "react";
import Modal from "./Modal";
import { useJoinWaitlistModal } from "../context/ModalContext";

const JoinWaitlistModal = ({ callToAction }: { callToAction: () => void }) => {
    const { isJoinWaitlistModalOpen, closeJoinWaitlistModal, joinWaitlist } = useJoinWaitlistModal();
    const [email, setEmail] = useState('');

    return (
        <Modal isOpen={isJoinWaitlistModalOpen} onClose={closeJoinWaitlistModal}>
            <div className="text-center bg-[#2A2A2A] flex flex-col p-[24px] rounded-[12px] gap-[24px]">
                <h2 className="text-[32px] font-semibold tracking-[-1.28px]">Join Waitlist</h2>
                <div className="flex flex-col gap-[12px]">
                    <input
                        id="email"
                        type="email"
                        placeholder="Enter your email"
                        className="w-full px-[24px] py-[12px] border border-white/30 rounded-[100px] focus:outline-none bg-transparent text-[16px] font-medium placeholder:text-white/30"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <button
                        onClick={() => joinWaitlist(email, callToAction)}
                        className="w-full px-[24px] font-medium py-[12px] bg-white text-black rounded-[100px]"
                    >
                        Submit
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default JoinWaitlistModal;
